import { Styles, generateClasses } from 'netline-ui';

export const preferencesListItemClasses = generateClasses('PreferencesListItem', ['root', 'title'] as const);

const styles: Styles = ({ theme: { colors, spacing } }) => ({
  [`&.${preferencesListItemClasses.root}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    padding: spacing(1, 0),
  },

  [`.${preferencesListItemClasses.title}`]: {
    color: colors.grey[900],
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: '0.5px',
    lineHeight: '24px',
  },
});

export default styles;
